import { render, staticRenderFns } from "./KpiDevelopment.vue?vue&type=template&id=8e852c82&"
import script from "./KpiDevelopment.vue?vue&type=script&lang=js&"
export * from "./KpiDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports